import React, { useState } from 'react';

import SelectExperiment from './SelectExperiment';
import ProjectField from 'containers/Mail/FormFields/ProjectField';
import SenderField from 'containers/Mail/FormFields/SenderField';
import UploadRecipients from './UploadRecipients';
import SubmitForm from './SubmitForm';

import useABTestForm from './useABTestForm';
import { SEND_THROUGH_LIST } from 'constants/common';
import { FormProvider } from 'react-hook-form';
import '../mail-form.css';

const CUSTOM_SEND_THROUGH_LIST = SEND_THROUGH_LIST.filter(
  v => v !== 'Gmail accounts',
);

const TemplateABTest = () => {
  const form = useABTestForm();
  const [isCsvValid, setIsCsvValid] = useState(false);
  const [totalRows, setTotalRows] = useState(0);

  return (
    <FormProvider {...form}>
      <div className="send-mail-form exp-send-mail-form">
        <SelectExperiment />

        <ProjectField title="ECS Project" />

        <SenderField sendThroughList={CUSTOM_SEND_THROUGH_LIST} />

        <UploadRecipients
          setIsCsvValid={setIsCsvValid}
          setTotalRows={setTotalRows}
        />

        <SubmitForm isCsvValid={isCsvValid} totalRows={totalRows} />
      </div>
    </FormProvider>
  );
};

export default TemplateABTest;
